import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reservacion-card',
  templateUrl: './reservacion-card.component.html',
  styleUrls: ['./reservacion-card.component.scss']
})
export class ReservacionCardComponent implements OnInit {

  @Input() public reservacion: any;

  constructor() {
  }

  ngOnInit(): void {
  }
}
